import useAuthClaims from '../../../hooks/useAuthClaims'
import { useAppDispatch, useAppSelector } from '../../../store'
import { useGetNextUpcomingReadingQuery } from '../../../generated/graphql'
import useLiveCallMonitorData from '../hooks/useLiveCallMonitorData'
import {
  selectLiveCallMonitorOpen,
  setLiveCallMonitorOpen,
} from '../slices/liveCallMonitorSlice'
import LiveCallMonitorDrawer from '../views/LiveCallMonitorDrawer'

const LiveCallMonitorDrawerContainer = () => {
  const dispatch = useAppDispatch()
  const { claims } = useAuthClaims()
  const role = claims?.role

  const canView = !!role && ['hlo-admin', 'librarian'].includes(role)

  const open = useAppSelector(selectLiveCallMonitorOpen)
  const { readings } = useLiveCallMonitorData({ skip: !canView })

  const nextUpcomingReadingQuery = useGetNextUpcomingReadingQuery({
    skip: !canView || readings.length > 0,
  })
  const nextReading = nextUpcomingReadingQuery.data?.reading[0]

  if (!canView) {
    return null
  }

  return (
    <LiveCallMonitorDrawer
      open={open}
      onClose={() => dispatch(setLiveCallMonitorOpen(false))}
      readings={readings}
      nextReadingStart={
        nextReading ? new Date(nextReading.readingstart) : undefined
      }
    />
  )
}

export default LiveCallMonitorDrawerContainer
